import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Group } from 'src/app/core/interfaces/group';

@Component({
  selector: 'app-group-advanced',
  templateUrl: './group-advanced.component.html',
  styleUrls: ['./group-advanced.component.scss']
})
export class GroupAdvancedComponent {

  form: FormGroup;
  

  constructor(private fb: FormBuilder){

    this.form = this.fb.group({
      QuoteApprovalsCount: new FormControl(null),
      AutoAcceptPrintQuote: new FormControl(true)
    });

  }
  
  
  setFormValue(param: any){


    this.form.get("QuoteApprovalsCount")?.setValue(param.QuoteApprovalsCount ?? null);
    this.form.get("AutoAcceptPrintQuote")?.setValue(param.AutoAcceptPrintQuote ?? false);


    this.form.updateValueAndValidity();
    this.form.markAllAsTouched();

  }


}
